/** Colour-coded status chip for job status. */

import { Chip, type ChipProps } from "@mui/material";

const STATUS_CONFIG: Record<string, { color: ChipProps["color"]; label: string }> = {
  pending: { color: "default", label: "Pending" },
  running: { color: "info", label: "Running" },
  complete: { color: "success", label: "Complete" },
  failed: { color: "error", label: "Failed" },
  completed_with_errors: { color: "warning", label: "Partial" },
};

export default function StatusChip({ status }: { status: string }) {
  const cfg = STATUS_CONFIG[status] ?? { color: "default" as const, label: status };
  return <Chip label={cfg.label} color={cfg.color} size="small" />;
}
